import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import icon from 'flarum/common/helpers/icon';
import humanTime from 'flarum/common/helpers/humanTime';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';

export default class DiscussionStickedNotification extends Notification {
  icon() {
    return 'fa-light fa-thumbtack';
  }

  // 覆盖 view 方法，不显示 avatar
  view(vnode) {
    const notification = this.attrs.notification;
    const href = this.href?.() ?? '';

    return (
      <Link
        className={classList('Notification', `Notification--${notification.contentType()}`, [!notification.isRead() && 'unread'])}
        href={href}
        external={href.includes('://')}
        onclick={this.markAsRead.bind(this)}
      >
        {/* 不显示 avatar */}
        {icon(this.icon?.(), { className: 'Notification-icon' })}
        <span className="Notification-title">
          <span className="Notification-content">{this.content?.()}</span>
          <span className="Notification-title-spring" />
          {humanTime(notification.createdAt())}
        </span>
        {!notification.isRead() && (
          <Button
            className="Notification-action Button Button--link"
            icon="fas fa-check"
            title={app.translator.trans('core.forum.notifications.mark_as_read_tooltip')}
            onclick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              this.markAsRead();
            }}
          />
        )}
        <div className="Notification-excerpt">{this.excerpt?.()}</div>
      </Link>
    );
  }

  href() {
    // 从 subject 获取讨论
    const discussion = this.attrs.notification.subject();
    
    if (discussion && typeof discussion.slug === 'function') {
      try {
        return app.route.discussion(discussion);
      } catch (e) {
        // 如果 discussion 对象不完整，尝试从 content 获取
      }
    }
    
    // 如果 subject 不可用，从 content 中获取 discussion_id 作为后备
    const content = this.attrs.notification.content();
    if (content && content.discussion_id) {
      const discussionModel = app.store.getById('discussions', content.discussion_id);
      if (discussionModel && typeof discussionModel.slug === 'function') {
        try {
          return app.route.discussion(discussionModel);
        } catch (e) {
          // 如果 discussion 对象不完整，返回空字符串
        }
      }
    }
    
    return '';
  }

  content() {
    const notification = this.attrs.notification;
    const fromUser = notification.fromUser();
    const username = fromUser ? fromUser.displayName() : '';
    
    return app.translator.trans('tf-cns-notifications.forum.notifications.discussion_sticked_text', {
      username: username
    });
  }

  excerpt() {
    return null;
  }
}

